export const glassEffect = {
  dark: {
    background: 'rgba(53, 84, 100, 0.73)',
    blur: '16px',
    border: '1px solid rgba(244, 233, 233, 0.38)',
    radius: '24px',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
  },
  darker: {
    background: 'rgba(29, 47, 56, 0.8)',
    blur: '16px',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    radius: '24px',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.36)',
    overlay: {
      background: 'rgba(0, 0, 0, 0.68)',
      blur: '12px'
    }
  }
};

export const applyGlass = (variant = 'dark') => `
  background: ${glassEffect[variant].background};
  backdrop-filter: blur(${glassEffect[variant].blur});
  border: ${glassEffect[variant].border};
  border-radius: ${glassEffect[variant].radius};
  box-shadow: ${glassEffect[variant].shadow};
`;

export const applyOverlay = () => `
  background: ${glassEffect.darker.overlay.background};
  backdrop-filter: blur(${glassEffect.darker.overlay.blur});
`; 